import { Entity } from '@backstage/catalog-model';
import {
  DefaultEntityFilters,
  EntityFilter,
  useEntityList,
} from '@backstage/plugin-catalog-react';
import { Box, MenuItem, Select, Typography } from '@material-ui/core';
import { entityTier } from '../ServiceTier';

const NOT_SET = 'none';

export class EntityTierFilter implements EntityFilter {
  constructor(readonly value: string) {}

  filterEntity(entity: Entity) {
    return (entityTier(entity) ?? NOT_SET) === this.value;
  }

  toQueryValue() {
    return this.value;
  }
}

export type CatalogFilters = DefaultEntityFilters & {
  tier?: EntityTierFilter;
};

/** Narrows the list to one service tier, or to services with no tier set. Laid out like the stock pickers beside it. */
export const TierPicker = () => {
  const { filters, updateFilters } = useEntityList<CatalogFilters>();
  return (
    <Box pt={1} pb={2}>
      <Typography
        variant="button"
        component="label"
        style={{ display: 'block', textTransform: 'none', lineHeight: '21px' }}
      >
        Tier
        <Select
          fullWidth
          displayEmpty
          variant="outlined"
          SelectDisplayProps={{
            style: {
              padding: '13.5px 14px',
              textTransform: 'none',
              fontWeight: 400,
            },
          }}
          value={filters.tier?.value ?? ''}
          onChange={event =>
            updateFilters({
              tier: event.target.value
                ? new EntityTierFilter(String(event.target.value))
                : undefined,
            })
          }
        >
          <MenuItem value="">All tiers</MenuItem>
          {['1', '2', '3', '4'].map(tier => (
            <MenuItem key={tier} value={tier}>
              Tier {tier}
            </MenuItem>
          ))}
          <MenuItem value={NOT_SET}>Not set</MenuItem>
        </Select>
      </Typography>
    </Box>
  );
};
